import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Encoding, GetEnumValuesDto, SmsCp, StatisticsSendStatus } from 'src/app/core/api/models';
import { OperatorTypesUi } from 'src/app/configs/operator-type-ui.config';

@Component({
    selector: 'app-doughnut-chart-today',
    templateUrl: './doughnut-chart-today.component.html',
    standalone: false
})
export class DoughnutChartTodayComponent implements OnInit {

  @Input() model: any[] = [];
  @Input() chartId: string = '';
  @Input() SmsCpEnumValues: GetEnumValuesDto[];
  @Input() StatisticsSendStatusEnumValues: GetEnumValuesDto[];

  labels: string[] = [];
  colors: string[] = [];
  data: number[] = [];
  title:string= this.translateService.instant('pages.statisticalReports.doughnutChartDescription');

  get Encoding() { return Encoding };
  get SmsCp() { return SmsCp };
  get StatisticsSendStatus() { return StatisticsSendStatus };
  constructor(private translateService: TranslateService) { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes["model"] || changes["StatisticsSendStatusEnumValues"] || changes["SmsCpEnumValues"])) {
      if (this.model?.length && this.model.some(a => a.items.length)
        && (this.SmsCpEnumValues?.length || this.StatisticsSendStatusEnumValues?.length)) {
        this.setData();
      }
    }
  }

  setData() {
    let labels2 = [];
    let colors2 = [];
    let data2 = [];
    this.model?.forEach(item => {
      let allPartsCount = 0;
      item.items.forEach(item2 => {
        allPartsCount += item2.partCount;
      });
      if (allPartsCount > 0) {
        labels2.push(this.SmsCpEnumValues.find(a => a.key == item.cpType)?.value);
        colors2.push(OperatorTypesUi.find(a => a.type == item.cpType)?.color);
        data2.push(allPartsCount);
      }
    });
    this.labels = labels2;
    this.colors = colors2;
    this.data = data2;
  }
}
